import PrivateRequest from '../app/modules/api/PrivateRequest'
import request from '../app/modules/api/request'

let isAuthorize = false


export const AuthReducer = (state = isAuthorize, action) => {
  switch (action.type) {
    case 'LOG_IN':
      console.log('action', action)
      if (action.payload.status === 200) {
        localStorage.setItem('token', action.payload.token)
        localStorage.setItem('userInfo', JSON.stringify(action.payload.userInfo))
        return !isAuthorize
      }
      console.log('isAuthorize')
      return !isAuthorize
    case 'LOG_OUT':
      PrivateRequest().post('logout/console').then((res) => {
        console.log('res expire token', res)
        return null
      }).catch((err) => {
        console.log('err expire token', err.data )
      })
      console.log('LOG_OUT', !isAuthorize)
      localStorage.clear()
      // window.location.reload()
      return isAuthorize = false
    default:
      if (localStorage.getItem('token')) {
        return isAuthorize = true
      }
      return isAuthorize = false
  }
}
